import React, { FC, useState } from "react"
import { Button, CircularProgress } from "@material-ui/core"
import { verifyUser } from "../../../../actions"
import styles from "./styles.module.scss"
import { User } from "../../../../types"

interface EditItemModalProps {
  listItem: User | null
  fetchData: () => void
  hideModal: () => void
}

export const ConfirmationVerify: FC<EditItemModalProps> = ({ listItem, fetchData, hideModal }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const onClickConfirm = async () => {
    if (!listItem) {
      return null
    }
    setIsLoading(true)

    await verifyUser(listItem?.id, +!listItem?.verified)

    hideModal()
    await fetchData()
    setIsLoading(false)
  }

  return (
    <div className={styles.confirmationVerifyContainer}>
      <span className={styles.title}>
        {listItem?.verified
          ? `Are you sure you would like to remove verification for ${listItem?.username}?`
          : `Are you sure you would like to verify ${listItem?.username}?`}
      </span>
      <div className={styles.confirmationVerifyButtonContainer}>
        <div className="button-container">
          {isLoading ? (
            <CircularProgress size={30} />
          ) : (
            <Button variant="contained" onClick={onClickConfirm}>
              Confirm
            </Button>
          )}
        </div>
        <Button variant="contained" onClick={hideModal}>
          Cancel
        </Button>
      </div>
    </div>
  )
}
